import { observeQuickView } from "./observeQuickView";

export const customAside = () => {
  document.addEventListener("click", (event) => {
    const openTrigger = event.target.closest("[data-aside-open]");
    const closeTrigger = event.target.closest(".custom-aside__close");
    const overlay = document.querySelector(".aside-overlay");
    const overlayQuickView = document.querySelector(
      ".aside-overlay--quickview"
    );

    if (openTrigger) {
      const targetKey = openTrigger.getAttribute("data-aside-open");
      const targetAside = document.querySelector(
        `.custom-aside[data-aside="${targetKey}"]`
      );

      if (targetAside) {
        const wrapper = targetAside.querySelector(".custom-aside__wrapper");
        if (wrapper) wrapper.scrollTop = 0;

        targetAside.classList.add("isActive");

        if (targetKey.includes("quickview")) {
          overlayQuickView.classList.add("isActive");
        } else {
          overlay.classList.add("isActive");
        }
      }
    }

    if (
      closeTrigger ||
      event.target === overlay ||
      event.target === overlayQuickView
    ) {
      const activeAside = document.querySelector(".custom-aside.isActive");
      const activeOverlayAside = document.querySelector(
        ".aside-overlay.isActive"
      );

      if (activeAside) {
        const wrapper = activeAside.querySelector(".custom-aside__wrapper");
        if (wrapper) wrapper.scrollTop = 0;

        activeAside.classList.remove("isActive");
        if (activeOverlayAside) activeOverlayAside.classList.remove("isActive");
      }
    }
  });

  observeQuickView();
};
